import { alertTypeLabels } from './constants'

export const getAlertTypeMenuItems = (availableAlertTypes, t) => {
  return availableAlertTypes.map(alertType => {
    return {
      label: t(alertTypeLabels[alertType] || alertType),
      value: alertType,
    }
  })
}
